document.addEventListener('DOMContentLoaded', () => {
  const switchPlan = document.querySelector('.switch-plan');
  const switcherBtns = document.querySelectorAll('.switcher .switcher-btn');
  const containers = [
    document.querySelector('.capsules-container.multicapsule'),
    document.querySelector('.capsules-container.tea'),
    document.querySelector('.capsules-container.espresso'),
  ];

  // --- throttle ---
  function throttle(fn, wait = 200) {
    let last = 0;
    return function (...args) {
      const now = Date.now();
      if (now - last >= wait) {
        last = now;
        return fn.apply(this, args);
      }
    };
  }

  // --- switcher ---
  switcherBtns.forEach(btn => {
    btn.addEventListener('click', function () {
      switcherBtns.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      containers.forEach(c => { if (c) c.style.display = 'none'; });
      const target = document.querySelector('.' + this.dataset.target);
      if (target) target.style.display = '';
    });
  });

  // --- initial state ---
  if (containers[0]) containers[0].style.display = '';
  if (containers[1]) containers[1].style.display = 'none';
  if (containers[2]) containers[2].style.display = 'none';

  if (switchPlan) {
    switchPlan.addEventListener('click', () => {
      window.location.href = '/pages/unlimited-capsules';
    });
  }

  // --- one-time cart clear (on first "Add" click only) ---
  let __cartClearedOnce = false;
  let __cartClearingInFlight = null;
  async function clearCartOnce() {
    if (__cartClearedOnce) return;
    if (__cartClearingInFlight) { await __cartClearingInFlight; return; }
    __cartClearingInFlight = fetch('/cart/clear.js', { method: 'POST' })
      .catch(err => console.error('Failed to clear cart:', err))
      .finally(() => {
        __cartClearedOnce = true;
        __cartClearingInFlight = null;
      });
    await __cartClearingInFlight;
  }
  window.__clearCartOnce = clearCartOnce; // expose for productAddFunctionality
  window.__CapsuleThrottle__ = throttle;  // expose for productAddFunctionality

  // --- product UI / selection wiring ---
  productAddFunctionality();

  // --- checkout submit handler (no cart clear here; we clear on first Add only) ---
  const submitBtn = document.querySelector('.submit_btn');
  let isSubmitting = false;

  async function addToCart(products) {
    const items = (products || [])
      .filter(p => p && p.variantId && Number(p.count) > 0)
      .map(p => ({ id: Number(p.variantId), quantity: Number(p.count) }));

    if (!items.length) {
      console.warn('No valid products to add.');
      return { ok: false, error: 'EMPTY_ITEMS' };
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        console.error('Add to cart failed:', data);
        return { ok: false, error: data?.description || data?.message || 'ADD_FAILED' };
      }

      const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await cartRes.json();
      return cart && cart.item_count > 0 ? { ok: true } : { ok: false, error: 'CART_EMPTY_AFTER_ADD' };
    } catch (err) {
      console.error('Network error adding to cart:', err);
      return { ok: false, error: 'NETWORK' };
    }
  }

  if (submitBtn) {
    submitBtn.addEventListener('click', async () => {
      if (isSubmitting) return;
      isSubmitting = true;
      submitBtn.disabled = true;
      submitBtn.classList.add('is-loading');
      submitBtn.style.pointerEvents = 'none';

      try {
        const products = Object.values(window.selectedProducts || {}).map(p => ({
          title: p.title,
          imgSrc: p.imgSrc,
          credit: p.credit,
          count: p.count,
          variantId: p.variantId
        }));

        const result = await addToCart(products);

        if (result.ok) {
          window.location.assign('/checkout');
        } else {
          alert('Could not proceed to checkout. Please review your selections and try again.');
          console.warn('Checkout blocked due to:', result.error);
        }
      } finally {
        setTimeout(() => {
          isSubmitting = false;
          submitBtn.disabled = false;
          submitBtn.classList.remove('is-loading');
          submitBtn.style.pointerEvents = '';
        }, 400);
      }
    });
  }
});

// ---------------------------
// Product selection logic
// ---------------------------
function productAddFunctionality() {
  const cards = document.querySelectorAll('.capsule-card');
  const productList = document.querySelector('.product_list');
  const productListPopup = document.querySelector('.product_list_popup');
  let firstAdd = true;

  if (!window.selectedProducts) window.selectedProducts = {};

  function updateRemainingCredits() {
    const balanceSpan = document.querySelector('.balance_container span');
    if (!balanceSpan) return;
    let balance = parseInt(balanceSpan.textContent, 10) || 0;

    let usedCredits = 0;
    Object.values(window.selectedProducts).forEach(p => {
      usedCredits += (parseInt(p.credit, 10) || 0) * (p.count || 1);
    });

    const remaining = balance - usedCredits;
    const remainingSpan = document.querySelector('.remaining_credits_count');
    if (remainingSpan) remainingSpan.textContent = remaining >= 0 ? remaining : 0;

    cards.forEach(card => {
      const addBtn = card.querySelector('.add-btn');
      const alreadyChosen = card.querySelector('.already_chosen_add');
      const creditNode = card.querySelector('.capsule-info span');
      const credit = creditNode ? (parseInt(creditNode.textContent, 10) || 0) : 0;
      if (addBtn) addBtn.disabled = remaining < credit;
      if (alreadyChosen) alreadyChosen.classList.toggle('disabled', remaining < credit);
    });
  }

  function updateCardActiveState(card, count) {
    const alreadyChosen = card.querySelector('.already_chosen_add');
    const addBtn = card.querySelector('.add-btn');
    if (!alreadyChosen) return;
    if (count > 0) {
      alreadyChosen.classList.add('active');
      if (addBtn) addBtn.style.display = 'none';
      const countSpan = alreadyChosen.querySelector('.count');
      if (countSpan) countSpan.textContent = count;
    } else {
      alreadyChosen.classList.remove('active');
      if (addBtn) addBtn.style.display = '';
      const countSpan = alreadyChosen.querySelector('.count');
      if (countSpan) countSpan.textContent = 0;
    }
  }

  if (!productList) {
    console.warn('.product_list not found in DOM — creating a fallback container to avoid runtime errors.');
    const fallback = document.createElement('div');
    fallback.className = 'product_list';
    document.body.appendChild(fallback);
  }

  const throttle = window.__CapsuleThrottle__ || (fn => fn);

  cards.forEach(card => {
    const addBtn = card.querySelector('.add-btn');
    const alreadyChosen = card.querySelector('.already_chosen_add');
    const titleNode = card.querySelector('.capsule-info h3');
    const creditNode = card.querySelector('.capsule-info span');
    const imgNode = card.querySelector('img');

    if (!titleNode || !creditNode || !imgNode || !addBtn) return;

    const title = titleNode.textContent.trim();
    const credit = parseInt(creditNode.textContent, 10) || 0;
    const imgSrc = imgNode.src;
    const variantId = card.dataset.variantId || null;

    const selectedProducts = window.selectedProducts;

    if (alreadyChosen) {
      const plusBtn = alreadyChosen.querySelector('.plus_btn');
      const minusBtn = alreadyChosen.querySelector('.minus_btn');

      if (plusBtn) {
        plusBtn.addEventListener('click', throttle(function (e) {
          e.stopPropagation();

          const balanceSpan = document.querySelector('.balance_container span');
          let balance = parseInt(balanceSpan?.textContent, 10) || 0;
          let usedCredits = 0;
          Object.values(window.selectedProducts).forEach(p => {
            usedCredits += (parseInt(p.credit, 10) || 0) * (p.count || 1);
          });
          const remaining = balance - usedCredits;
          if (remaining < credit) return;

          if (selectedProducts[variantId]) {
            selectedProducts[variantId].count += 1;
            updateCardActiveState(card, selectedProducts[variantId].count);

            const existingCard = Array.from(document.querySelectorAll('.mini-capsule-card'))
              .find(c => c.querySelector('.mini-capsule-info h4')?.textContent === title);
            if (existingCard) {
              const miniCountSpan = existingCard.querySelector('.mini-capsule-count');
              if (miniCountSpan) miniCountSpan.textContent = `x${selectedProducts[variantId].count}`;
            }
            updateRemainingCredits();
          }
        }, 200));
      }

      if (minusBtn) {
        minusBtn.addEventListener('click', throttle(function (e) {
          e.stopPropagation();

          if (selectedProducts[variantId] && selectedProducts[variantId].count > 1) {
            selectedProducts[variantId].count -= 1;
            updateCardActiveState(card, selectedProducts[variantId].count);

            const existingCard = Array.from(document.querySelectorAll('.mini-capsule-card'))
              .find(c => c.querySelector('.mini-capsule-info h4')?.textContent === title);
            if (existingCard) {
              const miniCountSpan = existingCard.querySelector('.mini-capsule-count');
              if (miniCountSpan) miniCountSpan.textContent = `x${selectedProducts[variantId].count}`;
            }
            updateRemainingCredits();
          } else if (selectedProducts[variantId] && selectedProducts[variantId].count === 1) {
            delete selectedProducts[variantId];
            updateCardActiveState(card, 0);

            const existingCard = Array.from(document.querySelectorAll('.mini-capsule-card'))
              .find(c => c.querySelector('.mini-capsule-info h4')?.textContent === title);
            if (existingCard) existingCard.remove();

            updateRemainingCredits();

            if (productList && productList.children.length === 0 && productListPopup) {
              productListPopup.classList.remove('active');
              firstAdd = true;
            }
          }
        }, 200));
      }
    }

    // --- ADD button: clear cart ONCE, then add to selection ---
    if(!addBtn.disabled) {
      addBtn.addEventListener('click', throttle(async function (event) {
        event.preventDefault();

        // clear Shopify cart only on the very first add click
        if (typeof window.__clearCartOnce === 'function') {
          await window.__clearCartOnce();
        }

        if (selectedProducts[variantId]) {
          selectedProducts[variantId].count += 1;
        } else {
          selectedProducts[variantId] = {
            title,
            imgSrc,
            credit,
            count: 1,
            variantId
          };
        }

        updateCardActiveState(card, selectedProducts[variantId].count);

        let existingCard = Array.from((document.querySelectorAll('.mini-capsule-card') || []))
          .find(c => c.querySelector('.mini-capsule-info h4')?.textContent === title);

        if (existingCard) {
          const countSpan = existingCard.querySelector('.mini-capsule-count');
          let count = parseInt(countSpan.textContent.replace('x', ''), 10) || 1;
          count++;
          countSpan.textContent = `x${count}`;
          updateRemainingCredits();
          return;
        }

        const miniCard = document.createElement('div');
        miniCard.className = 'mini-capsule-card';
        miniCard.innerHTML = `
          <button class="mini-capsule-remove" aria-label="remove item">&times;</button>
          <img src="${imgSrc}" alt="${title}" class="mini-capsule-img" />
          <div class="mini-capsule-info">
            <h4>${title}</h4>
            <span>${credit} <span class="mini-capsule-count">x1</span></span>
          </div>
        `;
        miniCard.style.position = 'relative';

        const removeBtn = miniCard.querySelector('.mini-capsule-remove');
        if (removeBtn) {
          removeBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            delete selectedProducts[variantId];
            miniCard.remove();
            updateCardActiveState(card, 0);
            updateRemainingCredits();

            if (productList && productList.children.length === 0 && productListPopup) {
              productListPopup.classList.remove('active');
              firstAdd = true;
            }
          });
        }

        if (productList) productList.appendChild(miniCard);

        if (firstAdd && productListPopup) {
          productListPopup.classList.add('active');
          firstAdd = false;
        }

        updateRemainingCredits();
      }, 200));
    }


    // initialize card UI if previously selected
    if (window.selectedProducts[variantId]) {
      updateCardActiveState(card, window.selectedProducts[variantId].count);
    } else {
      updateCardActiveState(card, 0);
    }
  });

  updateRemainingCredits();
}
